import { v4 as uuidv4 } from 'uuid';

export const DEFAULT_MATRIX = {
  rows: 4,
  columns: 4,
  segments: [
    {
      start: {
        row: 0,
        column: 0,
        height: 0
      },
      end: {
        row: 1,
        column: 3,
        height: 0
      }
    },
    {
      start: {
        row: 2,
        column: 0,
        height: 0
      },
      end: {
        row: 3,
        column: 3,
        height: 0
      }
    }
  ]
};

export const _initialState = {
  design: {
    sessionId: uuidv4(),
    designId: null,
    matrix: null,
    products: [],
    cart: [],
    selectedProduct: null,
    selectedVisualizerItemStackId: null,
    isZoomModalOpen: false,
    dragEvent: { isDragging: false, isVisualizerDrag: false },
    hasAccessories: false,
    isFromPip: false,
  },
  bundles: {
    added: [],
    data: null
  }
};
